import { Metric } from "@/entities/Finance/Finance.model";
import { DeltaLineageProps } from "./panels/DeltaLineagePanel";

export type DeltaFormula = { title?: string; formula: string[] };
export type DeltaResult = {
    value: number;
    previousFormula: DeltaFormula;
    currentFormula: DeltaFormula;
    deltaFormula: DeltaFormula;
};

export enum AIMViewType {
    DELTA_LINEAGE = "DELTA_LINEAGE",
    VALUE_LINEAGE = "VALUE_LINEAGE",
    LABS_LINEAGE = "LABS_LINEAGE",
    DATA_SOURCES_SETTINGS = "DATA_SOURCES_SETTINGS",
    INVESTMENT_CRITERIA = "INVESTMENT_CRITERIA",
}

export type SelectedCell = { gridId: string; rowId: string; colField: string };

export type AIMContextView =
    | {
          type: AIMViewType.DELTA_LINEAGE;
          props: DeltaLineageProps;
          isExpanded?: boolean;
          selectedCell?: SelectedCell;
      }
    | {
          type: AIMViewType.VALUE_LINEAGE;
          metric: Metric | null;
          period: string;
          title: string;
          isExpanded?: boolean;
          selectedCell?: SelectedCell;
      }
    | {
          type: AIMViewType.LABS_LINEAGE;
          metric: Metric | undefined;
          title: string;
          isExpanded?: boolean;
      }
    | {
          type: AIMViewType.DATA_SOURCES_SETTINGS;
          isExpanded?: boolean;
      }
    | {
          type: AIMViewType.INVESTMENT_CRITERIA;
          isExpanded?: boolean;
      };
